export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const fmt = (p) => `R${Number(p).toLocaleString('en-ZA', { minimumFractionDigits: 0 })}`;
export const CHUNK_SIZE = 500 * 1024; // 500 KB
export const MARKUP = 1.375;

export const DESIGNERS = [
  'AMI Paris', 'Amiri', 'Balenciaga', 'Bottega Veneta', 'Brunello Cucinelli',
  'Burberry', 'Cartier', 'Casablanca', 'Celine', 'Christian Louboutin', 'Dior',
  'Dolce & Gabbana', 'Fear Of God Essentials', 'Fendi', 'Givenchy', 'Gucci',
  'Hermès', 'Jil Sander', 'Jimmy Choo', 'Loewe', 'Loro Piana', 'Louis Vuitton',
  'Maison Margiela', 'Marine Serre', 'Miu Miu', 'Moncler', 'Off-White',
  'Palm Angels', 'Prada', 'Represent', 'Rhude', 'Saint Laurent',
  'Stone Island', 'Tom Ford', 'Valentino', 'Versace', 'Zegna',
];
export const CATEGORIES = ['Bags', 'Shoes', 'Clothing', 'Accessories'];
export const GENDERS = ['Women', 'Men', 'Unisex'];
export const CURRENCIES = ['ZAR', 'USD', 'GBP', 'EUR', 'AED'];
export const CAT_SIZES = {
  Bags: [],
  Shoes: ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46'],
  Clothing: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
  Accessories: [],
};

export const EMPTY_FORM = {
  name: '', designer: '', category: 'Bags', gender: 'Women', color: '',
  original_price: '', discounted_price: '', input_currency: 'ZAR',
  sizes: [], available_sizes: null,
  images: ['', '', ''],
  description: '', source_website: '', source_url: '', variant_group: '', is_active: true,
};
